import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
import TokenValidator from "../../fetchdata/TokenValidator";
import Cart from "./Cart";
import { useBlogContext } from "../../fetchdata/BlogContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";
import CreateSlug from "./extra/CreateSlug";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const MenuItem = ({ item }) => {
  return (
    <li key={item.id} className={item.children ? "has_submenu" : ""}>
      {item.children && item.children.length > 0 ? (
        <>
          <span>
            <Link
              to={item.link}
              target={item.target === "_blank" ? "_blank" : ""}
            >
              {item.text}
            </Link>
            <i class="ti ti-chevron-right"></i>
          </span>
          <SubMenu items={item.children} />
        </>
      ) : (
        <Link to={item.link} target={item.target === "_blank" ? "_blank" : ""}>
          {item.text}
        </Link>
      )}
    </li>
  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i class="ti ti-chevron-left"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const Header = () => {

  const navigate = useNavigate();

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
  
        // Save to localStorage
        localStorage.setItem("userLatitude", latitude);
        localStorage.setItem("userLongitude", longitude);
  
        console.log("Location saved");
      },
      function (error) {
        console.error("Location error:", error);
      }
    );
  }

  
     const driverObj = driver({
      showProgress: true,
      theme: 'yellow',  // Set the theme to yellow
      steps: [
        { element: '#tour-example', popover: { title: 'Select Location', description: 'Please choose your location to proceed.', side: "left", align: 'start' }},
       
      ]
    });
  
    useEffect(() => {
      const location = localStorage.getItem('location');
      if( location !== "[object Object]" && location){
        // navigate(`/loc/${location}`)
      }else{
       driverObj.drive();

      }
     }, []);
  
  
  
  const location = useLocation();

  const [user, setUser] = useState(null);

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };


  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    LocationHeaders,
    layout,
  } = useBlogContext();
  if (isHeader) {
    // console.log("Headers", Headers);
  }

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleSubMenu = (event) => {
    const submenu = event.target.nextElementSibling;
    submenu.classList.toggle("open");
  };

  const goBack = (event) => {
    const parentSubMenu = event.target.closest(".submenu");
    parentSubMenu.classList.remove("open");
  };


  useEffect(() => {
    $("#mobile_menu_container").removeClass("open");
    const storedUser = JSON.parse(getCookie("user"));
    setUser(storedUser);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);

    $("#mobile_menu_trigger").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_trigger_mob").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_container, .mobile_menu_close, .mobile_menu_close i").on(
      "click",
      function (e) {
        if (e.target === this) {
          $("#mobile_menu_container").toggleClass("open");
          /* $('#mobile_menu_container_inner').toggleClass('open'); */
        }
      }
    );

    $(document).on("click", "#mobile_menu .has_submenu > span", function () {
      $("+ .submenu", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .sub_sub_menu > span", function () {
      $("+ ul", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .mobile_menu_back", function () {
      $(this).closest("ul").removeClass("open");
    });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [SearchShow, setSearchShow] = useState(false);
  const handleFocus = () => {
    setSearchShow(true); // Update state when input is focused
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('e.target.value',e.target.value)
  };

  const handleClearClick = (value) => {
     
 
    const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname; // e.g., /delhi/anypage
    const pathSegments = currentPath.split('/');
   
    const locLiveSlug = pathSegments.find(segment => segment.trim()); // finds "gumia"
    const cleanLocLiveSlug = locLiveSlug?.trim(); // final cleaned slug
    
console.log('currentPath locSlug ', cleanLocLiveSlug , locSlug ,value)
    if(cleanLocLiveSlug === locSlug &&  (!Array.isArray(value) && typeof value !== 'object' || value === null) ){

      //  Replace the first segment if it's a location
    if (pathSegments.length > 1) {
      pathSegments[1] = CreateSlug(value.toLowerCase()); // set new location
    }
    const updatedPath = pathSegments.join('/');
    console.log('livepath ', updatedPath )

    //  window.location.href = updatedPath;
    navigate(updatedPath)

    }else{
      const fvalue = CreateSlug(value);
      
      if( fvalue == 'object-object'){
        navigate(`/`)
      }else{
        navigate(`/${CreateSlug(value)}`)
      }
    }
 

    setSearchQuery("");
    setSearchShow(false);
     if(value){
      localStorage.setItem('location', value);
    }
  };
  



  // const filteredLocations = LocationHeaders.filter((zone) => {
  //   // Check if the state name or any of its cities contains the search query
  //   return (
  //     zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // });

  const filteredLocations = LocationHeaders.filter((location) =>
    location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that this effect runs only once after initial render

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the value of isMenuOpen
  };

  // const isLogin = useSelector(state => state.isLogin)
  // console.log(isLogin)

  const dispatch = useDispatch();
  //state
  const [value, setValue] = useState();

  // const isLoginFromLocalStorage = localStorage.getItem("token") ? true : false;
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage]);

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      localStorage.clear();
      eraseCookie("token");
      eraseCookie("userId");
      eraseCookie("user");
      //  localStorage.removeItem("token");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("user");
    } catch (error) {
      console.log(error);
    }
  };
  const [isCartActive, setCartIsActive] = useState(false);

  const toggleCartClass = () => {
    setCartIsActive(!isCartActive);
  };


  return (
    <>
 <header className="header header-new">
  <div className="container-fluid">
    <nav className="navbar navbar-expand-lg header-nav">
      <div className="navbar-header">
       
      <Link to="/" className="navbar-brand logo"  >
                 {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                   <img
                     src={Headers.meta_logo}
                     width={120}
                     alt="logo"
                     style={{ maxHeight: 40, width: "auto" }}
                   />
                 ) : (
                   <div
                     className="card-1 skeleton"
                     style={{ borderRadius: 5, aspectRatio: "300/42",height:40 }}
                   ></div>
                 )}
               </Link>
               <Link
          to="/"
          className="navbar-brand logo-small"
        >
 {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                   <img
                     src={Headers.meta_logo}
                     width={100}
                     alt="logo"
                     style={{ maxHeight: 40, width: "auto" }}
                   />
                 ) : (
                   <div
                     className="card-1 skeleton"
                     style={{ borderRadius: 5, aspectRatio: "300/42" }}
                   ></div>
                 )}
               </Link>
         

        <a id="mobile_menu_trigger_mob" href="javascript:void(0);">
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </a>

      </div>
      <div className="main-menu-wrapper">
        <div className="menu-header">
          <a
            href="/"
            className="menu-logo"
          >
            <img
              src="/storage/logos/ae81yvTCzLSpELOsrQTxX5Z2COrHyI8PiTR7nqTb.svg"
              className="img-fluid"
              alt="Logo"
            />
          </a>
          <a id="menu_close" className="menu-close" href="javascript:void(0);">
            {" "}
            <i className="fas fa-times" />
          </a>
        </div>
        <div className="mobile-header d-flex flex-column justify-content-between h-100">
          <ul className="main-nav align-items-lg-center list-menus">
              <li   className={`input-group d-none d-lg-flex me-5 w-100 searchbox flex-fill ${!showSearch && "search-view" 
                   } `} 
                              style={{ backgroundColor: "#f3f7fb",maxWidth:'200px' }} id="tour-example"
                            >
                             
              
                              <input
                                id="searchInput"
                                className="form-control searchinput"
                                type="text"
                               
                                placeholder={localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location') ? localStorage.getItem('location') : "Search for state and cities"}
                                value={searchQuery  }
                                onChange={handleInputChange}
                                onFocus={handleFocus} // Call handleFocus when the input is focused
                                autoComplete="off" // Disable browser suggestions
                                defaultValue={localStorage.getItem('location')}
                                />
                              <button
                                type="button"
                                className="btn bg-white d-none d-lg-block search  text-secondary p-0 px-1 me-1" style={{background:'white'}}
                              >
                               <i className="ti ti-map-pin"></i>
                              </button>
            
                              { (searchQuery || SearchShow ) && (
                                <>
                                  <ul className="searchfloat">
            
                                  {filteredLocations.length > 0 ? (
                      filteredLocations.map((item) => {
                        const stateSlug = CreateSlug(item);
            
                        return (
                          <li key={item}>
                            {/* State option */}
                            <a type="button" className="bg-transparent border-0" onClick={() => handleClearClick(item)}>
                            <i className="ri-map-pin-2-fill"></i>  {item}
                            </a>
             
                          </li>
                        );
                      })
                    ) : (
                      <li className="p-3">No matching results</li>
                    )}
            
                              </ul>
                              </>
                            )}
            
            
                                    {/* {searchQuery &&
                                      filteredLocations &&
                                      filteredLocations.map((item) => {
                                        console.log("item.slug", item.slug);
                                        const myslug = CreateSlug(item.name); // Make sure `data` and `Product` are defined and available in the scope.
                                        return (
                                          <li key={item.id}>
                                            <Link
                                              to={`/product/${myslug}`}
                                              onClick={handleClearClick}
                                            >
                                              {" "}
                                              <i class="ri-shopping-bag-line"></i>{" "}
                                              {item.name}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                     */}
            
                                  
                               
            
                              {(searchQuery ||SearchShow ) && (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-primary bg-gradient d-none d-lg-block close"
                                    onClick={handleClearClick}
                                  >
                                    {" "}
                                     <i className="navbar-actions-icon ti ti-x"></i>
                                  </button>
                                </>
                              )}
                            </li>

           
              
                            {isHeader
                                 ? // Display loading skeletons while data is being fetched
                                 Array.from({ length: 5 }).map((_, index) => (
                                  <li className="nav-item" key={index}>
                                     <div
                                       className="skeleton "
                                       style={{
                                         height: 22,
                                         width: 80,
                                         borderRadius: 5,
                                       }}
                                     ></div>
                                   </li>
                                 ))
                                 : // Render first-level menu items
                                 Headers.header !== undefined &&
                                 Headers.header.slice(0, 10).map((item) => {
                                   return (
                                     <li className="nav-item" key={item.id}>
                                       <Link
                                         className={`nav-link ${item.children && item.children.length > 0
                                           ? "dropdown-toggle"
                                           : ""
                                           }`}
                                         to={
                                           item.children && item.children.length > 0
                                             ? "#"
                                             : item.link
                                         }
                                         {...(item.children &&
                                           item.children.length > 0 && {
                                           "data-bs-toggle": "dropdown",
                                         })}
                                       >
                                         {item.text}
                                       </Link>
           
                                       {item.children && item.children.length > 0 && (
                                         <>
                                           <div className="dropdown-menu p-0">
                                             <div className="row  px-2 py-2 pb-0">
                                               {item.children
                                                 .slice(0, 50)
                                                 .map((child) => (
                                                   <>
                                                     {" "}
                                                     <div className="col-md-12">
                                                       {" "}
                                                       <div className="widget widget-links mb-2 border-bottom
                                                       
                                                       ">
                                                         <h6 className="fs-base mb-3">
                                                           {" "}
                                                           <Link
                                                             className="widget-list-link"
                                                             to={child.link}
                                                             target={
                                                               child.target === "_blank"
                                                                 ? "_blank"
                                                                 : ""
                                                             }
                                                           >
                                                             <b> {child.text} </b>
                                                           </Link>
                                                         </h6>
                                                         <ul className="widget-list">
                                                           {child.children
                                                             .slice(0, 20)
                                                             .map((child) => (
                                                               <li className="widget-list-item">
                                                                 <Link
                                                                   className="widget-list-link"
                                                                   to={child.link}
                                                                   target={
                                                                     child.target ===
                                                                       "_blank"
                                                                       ? "_blank"
                                                                       : ""
                                                                   }
                                                                 >
                                                                   {child.text}
                                                                 </Link>
                                                               </li>
                                                             ))}
                                                         </ul>
                                                       </div>{" "}
                                                     </div>
                                                   </>
                                                 ))}
                                             </div>
                                           </div>
                                         </>
                                       )}
                                     </li>
                                   );
                                 })}
         
          </ul>
          <ul>
            <li className="nav-item px-3 py-1 w-100 d-lg-none d-block">
              <Link
                className="nav-link btn btn-light"
                to={'/login'}
                 
              >
                <i className="ti ti-lock me-2" />
                Signin
              </Link>
            </li>
            <li className="nav-item px-3 py-1 mb-3 d-lg-none d-block">
              <Link
                className="nav-link btn btn-linear-primary"
                 to={'/signup-user'}
               
              >
                <i className="ti ti-user-filled me-2" />
                Join us
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="header-btn d-flex align-items-center">
        <div className="provider-head-links d-block d-sm-none">
           
        </div>
      </div>
      <ul className="nav header-navbar-rht">
            {isLogin ? (
              <>
              
              <li className="nav-item pe-1">
          <Link
            className="nav-link btn btn-dark"
             to={'/account'}
          >
            <i className="ti ti-user me-2" />
            Account
          </Link>
        </li>
         <li className="nav-item pe-1">
          <button
          type="button"
            className="nav-link btn btn-danger"
             onClick={handleLogout}
          >
            <i className="ti ti-lock me-2" />
            Logout
          </button>
        </li>
        </>
              
             )
            : (
              <>
               <li className="nav-item pe-1">
          <Link
            className="nav-link btn btn-light"
             to={'/login'}
          >
            <i className="ti ti-lock me-2" />
            Signin
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link btn btn-linear-primary"
           to={'/signup-user'}
          >
            <i className="ti ti-user-filled me-2" />
            Join us
          </Link>
        </li>
              </>
            )}
       
      </ul>
    </nav>
  </div>
</header>

      <div id="mobile_menu_container" className="">
           <div id="mobile_menu_container_inner">
             <div className="mobile_menu_top">
               <Link to="/">
                 {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                   <img
                     src={Headers.meta_logo}
                     width={120}
                     alt="logo"
                     style={{ maxHeight: 50, width: "auto" }}
                   />
                 ) : (
                   <div
                     className="card-1 skeleton"
                     style={{ borderRadius: 5, aspectRatio: "300/42" }}
                   ></div>
                 )}
               </Link>
               <div className="mobile_menu_close">
                  <i class="ti ti-x"></i>
               </div>
             </div>
             <div id="mobile_menu_image_links"></div>
 
             <ul id="mobile_menu">
               {Headers.header &&
                 Headers.header.length > 0 &&
                 Headers.header.map((item) => (
                   <MenuItem key={item.id} item={item} />
                 ))}
 
               {/* 
               <li className="has_submenu">
                 <Link to="/allblogs">All Blogs</Link>
               </li>
 
               {isLogin ? (
                 <>
                   <li className="has_submenu">
                     <Link to="/account">Account</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link to="/wishList">Wishlist</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link to="/comparsion">Comparsion</Link>
                   </li>
 
                   <li className="has_submenu">
                     <Link onClick={handleLogout}>Logout</Link>
                   </li>
                 </>
               ) : (
                 <>
                   <li className="has_submenu">
                     <Link to="/comparsion">Login / Signup</Link>
                   </li>
                 </>
               )} 
                */}


             </ul>
           </div>
         </div>
 
 
    </>
  );
};

export default Header;
